import { NULL_AS_STRING } from '@repo/shared/dtos/beneficiary'
import { StringSchemaItem } from '@repo/shared/dtos/structured-data'
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@repo/ui/form'
import { useT } from '@repo/ui/hooks'
import { Input } from '@repo/ui/input'
import { useMemo } from 'react'

import { BaseForm } from '@/components/admin/structure-data/schema/forms/BaseForm'
import {
  StringFormValues,
  stringNullToString,
  stringToStringNull,
  stringValidationSchema,
} from '@/components/admin/structure-data/schema/forms/validation'

export function ItemStringForm({
  item,
  onUpdate,
}: {
  item: StringSchemaItem
  onUpdate: (item: StringSchemaItem) => void
}) {
  const { tc } = useT()

  const defaultValues = useMemo(
    () =>
      ({
        label: item.label,
        instructionsToFillValue: item.instructionsToFillValue,
        defaultValue: stringNullToString(item.defaultValue),
        type: 'string',
      }) satisfies StringFormValues,
    [item],
  )

  const handleUpdate = (values: StringFormValues) => {
    onUpdate({ ...item, ...values, defaultValue: stringToStringNull(values.defaultValue) })
  }

  return (
    <BaseForm defaultValues={defaultValues} onUpdate={handleUpdate} schema={stringValidationSchema}>
      {(formApi) => (
        <FormField
          control={formApi.control}
          name="defaultValue"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                {tc('defaultValue', { cfl: true })} ({tc('optional')})
              </FormLabel>
              <FormControl>
                <Input
                  {...field}
                  id="defaultValue"
                  placeholder={tc('defaultValue', { cfl: true })}
                  value={field.value === NULL_AS_STRING ? '' : field.value}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </BaseForm>
  )
}
